import * as React from 'react';
import PropTypes from 'prop-types';
import MuiTypography from '@mui/material/Typography';

function Typography({ children, variant = 'body1', marked = 'none', ...other }) {
    const getMarkStyle = () => {
        if (marked === 'center') {
            if (variant === 'h2') return { height: 4, width: 73, margin: '8px auto 0', backgroundColor: 'orange' };
            if (variant === 'h3' || variant === 'h4') return { height: 4, width: 55, margin: '8px auto 0', backgroundColor: 'orange' };
        }
        if (marked === 'left' && variant === 'h6') {
            return { height: 2, width: 28, marginTop: 4, backgroundColor: 'currentColor' };
        }
        return null;
    };

    const markStyle = getMarkStyle();

    return (
        <MuiTypography variant={variant} {...other}>
            {children}
            {markStyle && <div style={markStyle} />}
        </MuiTypography>
    );
}

Typography.propTypes = {
    children: PropTypes.node,
    marked: PropTypes.oneOf(['center', 'left', 'none']),
    variant: PropTypes.oneOf([
        'body1',
        'body2',
        'button',
        'caption',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'inherit',
        'overline',
        'subtitle1',
        'subtitle2',
    ]),
};

export default Typography;
